import type { ApiResponse } from "@/types/api";

import type { ApprovalQueueItem, ApprovalSubmission } from "./types";

export const formatApprovalLabel = (value: string | null | undefined) => {
    if (!value) return "—";

    return value
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (character) => character.toUpperCase());
};

export const getApprovalQueuePath = (approvalId: string) =>
    `/approval-queue/${approvalId}`;

export const buildApprovalSubmissionFeedback = (
    response: ApiResponse<ApprovalSubmission>,
    fallbackMessage = "Action submitted for approval."
) => {
    const baseMessage = (response.message || fallbackMessage).trim();
    const summary = response.data?.summary?.trim();

    if (!summary) {
        return baseMessage;
    }

    const normalizedBaseMessage = /[.!?]$/.test(baseMessage)
        ? baseMessage
        : `${baseMessage}.`;

    return `${normalizedBaseMessage} ${summary}.`;
};

export const isPendingApproval = (
    request: ApprovalQueueItem | null | undefined
): request is ApprovalQueueItem => request?.status === "PENDING";
